/**
 * StatsBar.jsx — the two KPI of the results header.
 *
 * Phase 5: only the metrics that answer a question the user actually has — how
 * many ETF were consolidated and how many distinct companies came out of it.
 * Follow-up: compact density, so the KPI can sit on the same band as the title
 * instead of pushing the data down.
 */
import { KpiCard } from "@/components/system";
import { formatNumber } from "@/utils/format";

export function StatsBar({ etfCount, uniqueHoldings, className = "" }) {
  return (
    <div
      className={`grid grid-cols-2 gap-2 sm:flex sm:flex-wrap sm:items-stretch sm:gap-3 ${className}`}
      data-testid="stats-bar"
    >
      <KpiCard
        testId="kpi-etfs"
        label="ETF analizzati"
        value={formatNumber(etfCount || 0)}
        density="compact"
        explain={{
          name: "ETF analizzati",
          what: "Quanti ETF sono inclusi in questa analisi.",
          how: "Corrisponde agli ETF selezionati per cui è stato caricato l'elenco delle holdings.",
        }}
      />
      <KpiCard
        testId="kpi-unique-holdings"
        label="Holdings uniche"
        value={formatNumber(uniqueHoldings || 0)}
        density="compact"
        explain={{
          name: "Holdings uniche",
          what: "Numero di società distinte presenti in almeno uno degli ETF selezionati.",
          how: "Una società che compare in più ETF viene contata una volta sola.",
          coverage: "Dipende dalla copertura delle holdings pubblicate dagli emittenti.",
        }}
      />
    </div>
  );
}
